import styled from 'styled-components';

import ProgressBar from '~src/shared/ProgressBar';
import { fadeIn } from '~src/styles/animations/animations.sc';
import { media } from '~src/styles/media-templates';

export const MainHeader = styled.div`
  font-size: 1.3125rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.white.a10};
`;

export const SubHeader = styled.div`
  font-size: 0.9375rem;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.white.a6};
`;

export const UpToDate = styled.div`
  padding-top: 5px;
`;

export const RemainingKRs = styled.div`
  font-size: 0.9375rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.white.a6};
  max-width: 750px;
`;

export const ProgressContainer = styled.div`
  width: 100%;
  max-width: 540px;
  margin: 0 auto;
  margin-top: 30px;
`;

export const ProgressBarInverted = styled(ProgressBar)`
  margin-top: 5px;
  background-color: ${({ theme }) => theme.white.a1};

  > div {
    background-color: ${({ theme }) => theme.white.a10};
  }
`;

export const CurrentInfo = styled.div`
  margin-top: 30px;
  width: 100%;
  ${media.phone`
    margin-top: 15px;
  `}
`;

export const NextContainer = styled.div`
  width: 100%;
`;
export const NextInfo = styled.div`
  margin-top: 10px;
  color: ${({ theme }) => theme.white.a10};
  display: flex;
  flex-direction: row;
  justify-content: start;
  ${media.phone`
    margin-top: 15px;
  `}
`;

export const ButtonContainer = styled.div<{ $redirect: boolean }>`
  opacity: ${({ $redirect }) => ($redirect ? '0' : '1')};
  transition: all ease 1s;
  width: 326px;
  height: 355px;
  display: flex;
  align-items: flex-end;
  ${media.phone`
    height: auto;
  `}
`;

export const RedirectContentWrapper = styled.div<{ $redirect: boolean; $height: string | number }>`
  width: 100%;
  text-align: center;
  color: ${({ theme }) => theme.white.a10};
  font-size: 2.5rem;
  margin-left: ${({ $redirect }) => ($redirect ? '-100%' : '0')};
  transition: margin-left ease 1s;
  background-color: ${({ theme }) => theme.baseBlue.a10};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 3.333333rem 0 3.333333rem;
  height: ${({ $height }) => $height};
  align-self: center;

  @media only screen and (min-height: 833px) {
    display: 'flex';
  }

  ${media.phone`
    background-color: ${({ theme }) => theme.mobileBlue.a10};
    margin-left: 0;
    padding: 30px 10px;
    height: 100%;
  `}
`;

export const LinkContainer = styled.div`
  padding-top: 27px;
`;

export const ObjectiveDoneMessageContainer = styled.div`
  width: 540px;
  text-align: center;
  padding-top: 60px;
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 60px;
  border-top: 1px solid ${({ theme }) => theme.white.a3};
`;

export const ObjectiveProgressContainer = styled.span<{ $blurOnMobile?: boolean }>`
  width: 100%;
  animation: ${fadeIn} 0.3s;
  opacity: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${media.phone`
    filter: ${({ $blurOnMobile }) => ($blurOnMobile ? 'blur(20px)' : 'none')};
    transition: all 1s ease;
  `}
`;
